import React from "react"

import { ReactComponent as LookersLogo } from "../../../assets/svg/LookersLogo.svg"
import { ReactComponent as CharlesHurstLogo } from "../../../assets/svg/CharlesHurstLogo.svg"
import { Faqs } from "./Faqs"
import "./Header.scss"

interface HeaderProps {
  groupId: number
}

export const Header: React.FC<HeaderProps> = ({ groupId }) => {

  const BASE_URL = `${window.location.origin}`
  const LookersFAQ = 'https://www.lookers.co.uk/terms-and-conditions/click-and-sell-faqs'
  const CharlesHurstFAQ = 'https://www.charleshurstgroup.co.uk/terms-and-conditions/click-and-sell-faqs'

  const logoToRender = (groupId: number) => {
    switch (groupId) {
      case 1:
        return (        
          <LookersLogo aria-label="Lookers logo" />
        )
      case 2:
        return (
          <CharlesHurstLogo aria-label="Charles Hurst logo" />        
        )
      default:
        return <></>
    }
  }

  return (
    <header className="header">
      <div>
        <a href={BASE_URL}>
          {logoToRender(groupId)}
        </a>
      </div>
      <div className="header-seperator"></div>
      <div className="header-contact">
        <div className="faqs-contact">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={groupId === 1 ? LookersFAQ : CharlesHurstFAQ}
          >
            <Faqs />
            <p className="faq-p">FAQs</p>
          </a>
        </div>
      </div>
    </header>
  )
}
